import React from 'react';

const TimelineContext = React.createContext(null);

export { TimelineContext };
